/**
 * Popup de bienvenue — code -10 % sur la première commande (BIENVENUE10)
 * Les As du Volant
 *
 * Le code existe dans l'admin (Réductions) : 10 % sur tout, 1 utilisation par
 * client, non cumulable avec les autres codes produit/commande. Le CTA
 * WhatsApp pré-remplit le code dans le message, puisque l'essentiel des
 * commandes se conclut sur WhatsApp (devis / commande provisoire).
 */
(function () {
  'use strict';

  var POPUP_DELAY_MS = 12000;
  var EXIT_INTENT_MIN_MS = 8000;
  var PROMO_CODE = 'BIENVENUE10';
  // Nouveau nom de cookie : les visiteurs qui avaient déjà vu l'ancien pop-up
  // « visuel 3D » voient quand même l'offre de bienvenue une fois.
  var COOKIE_NAME = '_lav_dpop10_shown';
  var COOKIE_DAYS = 30;
  var WHATSAPP_NUMBER = '33644650200';

  var pageLoadTime = Date.now();
  var waitingForConsent = false;

  function getCookie(name) {
    var match = document.cookie.match('(?:^|;)\\s*' + name + '=([^;]*)');
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; expires=' + date.toUTCString() + '; path=/; SameSite=Lax';
  }

  function hasBeenShown() {
    return getCookie(COOKIE_NAME) === '1';
  }

  function markAsShown() {
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
  }

  function consentBannerVisible() {
    var banner = document.getElementById('shopify-pc__banner');
    return !!(banner && banner.offsetParent !== null);
  }

  function showPopup() {
    if (hasBeenShown()) return;
    if (document.querySelector('#cart-whatsapp-popup.cwp-visible')) return;

    // Un seul overlay à la fois : tant que le bandeau cookies est affiché,
    // on attend la réponse au consentement puis on retente 2 s après.
    if (consentBannerVisible()) {
      if (!waitingForConsent) {
        waitingForConsent = true;
        document.addEventListener('visitorConsentCollected', function () {
          setTimeout(showPopup, 2000);
        }, { once: true });
      }
      return;
    }

    markAsShown();

    var whatsappMessage = encodeURIComponent(
      'Bonjour \u{1F44B}, je souhaite profiter de mon code ' + PROMO_CODE +
      ' (-10 % sur ma première commande) pour mon volant personnalisé.'
    );
    var whatsappUrl = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + whatsappMessage;

    var overlay = document.createElement('div');
    overlay.className = 'dpop-overlay';

    var container = document.createElement('div');
    container.className = 'dpop-container';
    container.setAttribute('role', 'dialog');
    container.setAttribute('aria-modal', 'true');
    container.setAttribute('aria-label', '10 % offerts sur votre première commande');

    container.innerHTML =
      '<div class="dpop-card">' +
        '<div class="dpop-glow-bar"></div>' +
        '<div class="dpop-particles">' +
          '<div class="dpop-particle"></div>' +
          '<div class="dpop-particle"></div>' +
          '<div class="dpop-particle"></div>' +
          '<div class="dpop-particle"></div>' +
          '<div class="dpop-particle"></div>' +
        '</div>' +
        '<button class="dpop-close" aria-label="Fermer">&times;</button>' +
        '<div class="dpop-inner">' +
          '<h2 class="dpop-title"><span class="dpop-highlight">10 % offerts</span> sur votre première commande</h2>' +
          '<p class="dpop-subtitle">Votre code de bienvenue, valable sur <strong>tous nos volants et options</strong>.</p>' +
          '<button type="button" class="dpop-code" aria-label="Copier le code ' + PROMO_CODE + '">' +
            '<span class="dpop-code-value">' + PROMO_CODE + '</span>' +
            '<span class="dpop-code-action">Copier</span>' +
          '</button>' +
          '<a href="' + whatsappUrl + '" target="_blank" rel="noopener noreferrer" class="dpop-wa-button">' +
            '<svg viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>' +
            'J’en profite sur WhatsApp' +
          '</a>' +
          '<button class="dpop-skip">Non merci, je continue</button>' +
          '<p class="dpop-footer-text">Code à saisir au paiement ou à indiquer sur WhatsApp • 1 utilisation par client</p>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.appendChild(container);

    requestAnimationFrame(function () {
      overlay.classList.add('dpop-visible');
      container.classList.add('dpop-visible');
    });

    function closePopup() {
      overlay.classList.remove('dpop-visible');
      container.classList.remove('dpop-visible');
      setTimeout(function () {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        if (container.parentNode) container.parentNode.removeChild(container);
      }, 500);
    }

    var closeBtn = container.querySelector('.dpop-close');
    var skipBtn = container.querySelector('.dpop-skip');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (skipBtn) skipBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);

    var codeBtn = container.querySelector('.dpop-code');
    if (codeBtn) codeBtn.addEventListener('click', function () {
      var label = codeBtn.querySelector('.dpop-code-action');
      function done() {
        codeBtn.classList.add('dpop-code--copied');
        if (label) label.textContent = 'Copié ✓';
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(PROMO_CODE).then(done, done);
      } else {
        done();
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'popup_code_copy', promo_code: PROMO_CODE });
    });
  }

  function setupExitIntent() {
    var exitFired = false;

    function onMouseLeave(e) {
      if (e.clientY > 0 || exitFired) return;
      if (Date.now() - pageLoadTime < EXIT_INTENT_MIN_MS) return;
      exitFired = true;
      showPopup();
      document.removeEventListener('mouseleave', onMouseLeave);
    }

    document.addEventListener('mouseleave', onMouseLeave);
  }

  function init() {
    if (hasBeenShown()) return;
    setTimeout(function () {
      if (!hasBeenShown()) showPopup();
    }, POPUP_DELAY_MS);
    setupExitIntent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
